import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { SingleValue } from 'react-select';

import { IStore } from '../../../../services/api/troubleshooting-service';
import CurrentPortalStore from '../../../../stores/current-portal-store';
import { IOption, SelectDropdown } from '../../../../components/inputs/select-dropdown/select-dropdown';
import { Input } from '../../../../components/inputs/input/input';
import { Button } from '../../../../components/inputs/button/button';
import TroubleshootingStore from '../../troubleshooting-page-store';

import OrderEligibilityDisplay from './order-eligibility-display/order-eligibility-display';
import './order-eligibility-page.scss';

const OrderEligibilityPage: React.FC = observer(() => {
    const [chosenStore, setChosenStore] = useState<IOption | null>(null);
    const [orderName, setOrderName] = useState('');
    const [shopifyResponse, setShopifyResponse] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        TroubleshootingStore.fetchStores();
        CurrentPortalStore.load();
    }, []);

    const portalId = CurrentPortalStore.currentPortal.id;
    const portalName = CurrentPortalStore.currentPortal.name;
    const portalDisplayName = CurrentPortalStore.currentPortal.displayName;

    useEffect(() => {
        if (chosenStore?.value !== portalId && portalId && portalName) {
            setChosenStore({
                value: portalId,
                label: portalName + (portalDisplayName ? ' (' + portalDisplayName + ')' : '')
            });
        }
    }, [portalId, portalName, portalDisplayName, chosenStore?.value]);

    /** patch to prevent react warning */
    const __shopifyResponse = TroubleshootingStore.shopifyResponse;
    useEffect(() => {
        setShopifyResponse(toJS(TroubleshootingStore.shopifyResponse));
        setIsLoading(false);
    }, [__shopifyResponse]);

    const generateSelectValues = (): IOption[] | [] => {
        return TroubleshootingStore.stores?.map((el: IStore): IOption => {
            return {
                value: el.id,
                label: el.name + (el.display_name ? ' (' + el.display_name + ')' : '')
            }
        }) || [];
    }

    const onStoreChangeHandler = (val: SingleValue<IOption>) => {
        if (val) setChosenStore(val);
    }

    const handleOrderNameChange = (val: any) => {
        setOrderName(val);
    }

    const onEnterKeyPressSubmit = () => {
        performFetch();
    }

    const performFetch = () => {
        if (chosenStore?.value && orderName) {
            setIsLoading(true);
            TroubleshootingStore.fetchOrderEligibility(chosenStore.value, orderName);
        }
    }

    const canPerformFetch = chosenStore?.value && orderName.trim().length > 0;

    return (
        <div className="order-eligibility-page">
            <div className="card">
                <h4>Request Information</h4>
                <div className="controls">
                    <p className="head5">Store</p>
                    <SelectDropdown
                        required
                        value={chosenStore || undefined}
                        placeholder="Type to find and select store"
                        options={generateSelectValues()}
                        onChange={onStoreChangeHandler}
                    />
                </div>
                <div className="controls">
                    <p className="head5">Order Name</p>
                    <Input
                        required
                        value={orderName}
                        onChange={handleOrderNameChange}
                        onSubmit={onEnterKeyPressSubmit}
                    />
                </div>
                <Button
                    disabled={!canPerformFetch}
                    text="Fetch"
                    onClick={performFetch}
                />
            </div>

            {isLoading && !shopifyResponse?.data && (
                <div className="card">
                    <p>Loading...</p>
                </div>
            )}

            {shopifyResponse?.data && (
                <div className="card results-card">
                    <OrderEligibilityDisplay
                        data={shopifyResponse.data}
                        orderName={orderName}
                    />
                </div>
            )}
        </div>
    );
});

export default OrderEligibilityPage;

